(function(){
     'use strict';

     angular
        .module('appback')
        .factory('AppmovService', AppmovService);

    AppmovService.$inject = ['$http'];

    function AppmovService($http){


        var service= {
           getCuentaInfo:getCuentaInfo
        };

        return service;
 		function getCuentaInfo(crm_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               crm_id:crm_id
            });
            $http.post('/backend/app/getinfocuenta', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                return false;
            }
        }
    }
})();